module.exports = __webpack_public_path__ + "static/media/pierre-light.b4b25534.png";